import { gql } from "@apollo/client";

/**
 * `/n2?indicateurId=...` resolution — Phase 9C.3B.5.
 *
 * Reuses the existing single-id `indicateur(id: ID!): Indicateur` query
 * (`packages/nbs-graphql/src/schema/typeDefs.ts` line ~136, resolver
 * `packages/nbs-graphql/src/resolvers/queries.ts` — `authorize("indicateur", ...)`
 * then `ctx.facade.getIndicateur(...)`) — no new query, no schema change.
 *
 * Field selection is intentionally minimal: just enough to confirm which
 * indicateur was resolved (`id`, `libelle`) plus its own scalar
 * definition fields (`uniteDefaut`, `definition`, `frequence`) — no
 * `serviceEcosystemiqueId` selected. Not because the field doesn't exist
 * on the real `Indicateur` SDL type (it does — unlike
 * `N1AggregatedIndicator`, which never exposes it, see
 * `ADR_N1_WIDGET_NAVIGATION.md` §W6), but because this phase's minimal
 * target render has no legitimate use for it: displaying it would invite
 * exactly the kind of "jointure avec les risques, priorités" this phase
 * explicitly forbids (§4.3), since the only thing this render does with
 * an indicateur's own detail fields is display them as-is, never join
 * them with `readingN1.priorities`/`risks`/`trends`.
 */
export const INDICATEUR_DETAIL_QUERY = gql`
  query IndicateurDetail($id: ID!) {
    indicateur(id: $id) {
      id
      libelle
      uniteDefaut
      definition
      frequence
    }
  }
`;
